import React from 'react';
import { UserIcon, Users2Icon } from 'lucide-react';
import { GroupTherapyIcon } from './GroupTherapyIcon';
export const Services = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="w-full py-8 px-6 md:px-10 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden" data-id="element-233">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#3d8f5a]/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-234" />
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-235">
        <div className="text-center mb-10 space-y-3" data-id="element-236">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-237">
            Форматы терапии
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-238">
            Как мы можем встретиться
          </p>
        </div>
        <div className="grid lg:grid-cols-3 gap-8" data-id="element-239">
          {/* Individual Therapy */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 flex flex-col" data-id="element-240">
            <div className="flex items-center gap-4 mb-6" data-id="element-241">
              <div className="w-12 h-12 rounded-xl bg-[#3d8f5a]/10 flex items-center justify-center" data-id="element-242">
                <UserIcon className="w-6 h-6 text-[#3d8f5a]" data-id="element-243" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-244">
                Индивидуальная
              </h3>
            </div>
            <p className="text-gray-600 mb-8" data-id="element-245">Личные сессии один на один</p>
            <div className="space-y-6 flex-grow" data-id="element-246">
              <div className="space-y-3" data-id="element-247">
                <div className="text-sm font-semibold text-gray-900" data-id="element-248">
                  Онлайн
                </div>
                <div className="space-y-2 text-sm text-gray-600" data-id="element-249">
                  <div className="flex justify-between" data-id="element-250">
                    <span data-id="element-251">Стоимость</span>
                    <span className="font-semibold text-gray-900" data-id="element-252">
                      7 000 ₽ (≈75€)
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-253">
                    <span data-id="element-254">Длительность</span>
                    <span className="font-semibold text-gray-900" data-id="element-255">55 мин</span>
                  </div>
                </div>
              </div>
              <div className="space-y-3 pt-4 border-t border-gray-100" data-id="element-256">
                <div className="text-sm font-semibold text-gray-900" data-id="element-257">
                  Очно в Париже
                </div>
                <div className="space-y-2 text-sm text-gray-600" data-id="element-258">
                  <div className="flex justify-between" data-id="element-259">
                    <span data-id="element-260">Стоимость</span>
                    <span className="font-semibold text-gray-900" data-id="element-261">110 €</span>
                  </div>
                  <div className="flex justify-between" data-id="element-262">
                    <span data-id="element-263">Длительность</span>
                    <span className="font-semibold text-gray-900" data-id="element-264">55 мин</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-auto" data-id="element-265">
              <p className="text-sm text-gray-500 text-center mt-8 mb-3" data-id="element-266">
                Оплата в удобной для вас валюте
              </p>
              <button onClick={scrollToContact} className="w-full py-3 bg-[#3d8f5a] text-white font-semibold rounded-xl hover:bg-[#2c5f2d] transition-colors" data-id="element-267">
                Записаться
              </button>
            </div>
          </div>
          {/* Couple Therapy */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 flex flex-col" data-id="element-268">
            <div className="flex items-center gap-4 mb-6" data-id="element-269">
              <div className="w-12 h-12 rounded-xl bg-[#3d8f5a]/10 flex items-center justify-center" data-id="element-270">
                <Users2Icon className="w-6 h-6 text-[#3d8f5a]" data-id="element-271" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-272">Парная</h3>
            </div>
            <p className="text-gray-600 mb-8" data-id="element-273">Для пар и родственников</p>
            <div className="space-y-6 flex-grow" data-id="element-274">
              <div className="space-y-3" data-id="element-275">
                <div className="text-sm font-semibold text-gray-900" data-id="element-276">
                  Онлайн
                </div>
                <div className="space-y-2 text-sm text-gray-600" data-id="element-277">
                  <div className="flex justify-between" data-id="element-278">
                    <span data-id="element-279">Стоимость</span>
                    <span className="font-semibold text-gray-900" data-id="element-280">
                      14 000 ₽ (≈150€)
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-281">
                    <span data-id="element-282">Длительность</span>
                    <span className="font-semibold text-gray-900" data-id="element-283">90 мин</span>
                  </div>
                </div>
              </div>
              <div className="space-y-3 pt-4 border-t border-gray-100" data-id="element-284">
                <div className="text-sm font-semibold text-gray-900" data-id="element-285">
                  Очно в Париже
                </div>
                <div className="space-y-2 text-sm text-gray-600" data-id="element-286">
                  <div className="flex justify-between" data-id="element-287">
                    <span data-id="element-288">Стоимость</span>
                    <span className="font-semibold text-gray-900" data-id="element-289">180 €</span>
                  </div>
                  <div className="flex justify-between" data-id="element-290">
                    <span data-id="element-291">Длительность</span>
                    <span className="font-semibold text-gray-900" data-id="element-292">90 мин</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-auto" data-id="element-293">
              <p className="text-sm text-gray-500 text-center mt-8 mb-3" data-id="element-294">
                Оплата в удобной для вас валюте
              </p>
              <button onClick={scrollToContact} className="w-full py-3 bg-[#3d8f5a] text-white font-semibold rounded-xl hover:bg-[#2c5f2d] transition-colors" data-id="element-295">
                Записаться
              </button>
            </div>
          </div>
          {/* Group Therapy */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 flex flex-col" data-id="element-296">
            <div className="flex items-center gap-4 mb-6" data-id="element-297">
              <div className="w-12 h-12 rounded-xl bg-[#3d8f5a]/10 flex items-center justify-center" data-id="element-298">
                <GroupTherapyIcon className="w-6 h-6 text-[#3d8f5a]" data-id="element-299" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-300">Групповая</h3>
            </div>
            <p className="text-gray-600 mb-8" data-id="element-301">
              Совместные встречи в небольшой группе для поддержки и решения
              личных трудностей по определенной тематике
            </p>
            <div className="space-y-2 text-sm text-gray-600 pt-4 border-t border-gray-100 flex-grow" data-id="element-302">
              <div className="flex justify-between" data-id="element-303">
                <span data-id="element-304">Как часто</span>
                <span className="font-semibold text-gray-900" data-id="element-305">
                  2 раза/мес. × 2 ч
                </span>
              </div>
              <div className="flex justify-between" data-id="element-306">
                <span data-id="element-307">Стоимость</span>
                <span className="font-semibold text-gray-900" data-id="element-308">
                  10 000 ₽ (≈100€)
                </span>
              </div>
              <div className="flex justify-between" data-id="element-309">
                <span data-id="element-310">Участников</span>
                <span className="font-semibold text-gray-900" data-id="element-311">5-6 человек</span>
              </div>
            </div>
            <div className="mt-auto" data-id="element-312">
              <p className="text-sm text-gray-500 text-center mt-8 mb-3" data-id="element-313">
                Оплата в удобной для вас валюте
              </p>
              <button onClick={scrollToContact} className="w-full py-3 bg-[#3d8f5a] text-white font-semibold rounded-xl hover:bg-[#2c5f2d] transition-colors" data-id="element-314">
                Записаться
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};